import axios from "../../axios";

const updateInfo = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('admin/administration/updateInfo', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateInfo;
